import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import userInfoStorage from '@/store/module/userInfo'
import supervStorage from '@/store/module/superv-index'
import readingStatusStorage from "@/store/module/reading-status-index";
import adminInfoStorage from "@/store/module/adminInfo-index"
export default createStore({
  modules: {
    userInfoStorage,
    supervStorage,
    readingStatusStorage,
    adminInfoStorage
  },
  plugins: [createPersistedState({
    paths: ['userInfoStorage', 'supervStorage','readingStatusStorage','adminInfoStorage']
  })]
})